__turbopack_context__.v({
  "ctaWrapper": "HeroSection-module__3txOzG__ctaWrapper",
  "desktopImage": "HeroSection-module__3txOzG__desktopImage",
  "mobileImage": "HeroSection-module__3txOzG__mobileImage",
  "productWrapper": "HeroSection-module__3txOzG__productWrapper",
  "section": "HeroSection-module__3txOzG__section",
  "tagline": "HeroSection-module__3txOzG__tagline",
  "textBlock": "HeroSection-module__3txOzG__textBlock",
  "wordmark": "HeroSection-module__3txOzG__wordmark",
});
